import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      {/* Main Navbar */}
      <nav className="bg-gradient-to-r from-blue-600 to-teal-600 text-white flex justify-between items-center px-6 py-4 shadow-lg">
        <div className="text-2xl font-extrabold tracking-wide">
          <Link to="/" className="hover:text-teal-200 transition-all duration-200">
            Query Minds
          </Link>
        </div>
        <button
          className="text-white text-3xl md:hidden focus:outline-none"
          onClick={toggleMenu}
        >
          ☰
        </button>
        <ul className="hidden md:flex space-x-8 font-medium text-lg">
          <li>
            <Link
              to="/"
              className="hover:text-teal-200 transition-all duration-200"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className="hover:text-teal-200 transition-all duration-200"
            >
              About Us
            </Link>
          </li>
          <li>
            <Link
              to="/services"
              className="hover:text-teal-200 transition-all duration-200"
            >
              Services
            </Link>
          </li>
          <li>
            <Link
              to="/projects"
              className="hover:text-teal-200 transition-all duration-200"
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="hover:text-teal-200 transition-all duration-200"
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>

      {/* Mobile Fullscreen Menu */}
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-gradient-to-b from-blue-600 to-teal-600 text-white flex flex-col items-center justify-center z-50"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          {/* Close Button */}
          <button
            className="absolute top-6 right-6 text-white text-4xl font-bold focus:outline-none hover:text-teal-300 transition-all duration-200"
            onClick={toggleMenu}
          >
            ✕
          </button>

          {/* Brand Name */}
          <div className="text-4xl font-extrabold mb-12 tracking-wide">
            Query Minds
          </div>

          {/* Navigation Links */}
          <ul className="space-y-8 text-2xl font-medium">
            <li>
              <Link
                to="/"
                onClick={toggleMenu}
                className="hover:text-teal-300 transition-all duration-200"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                onClick={toggleMenu}
                className="hover:text-teal-300 transition-all duration-200"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                onClick={toggleMenu}
                className="hover:text-teal-300 transition-all duration-200"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                onClick={toggleMenu}
                className="hover:text-teal-300 transition-all duration-200"
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                onClick={toggleMenu}
                className="hover:text-teal-300 transition-all duration-200"
              >
                Contact
              </Link>
            </li>
          </ul>
        </motion.div>
      )}
    </div>
  );
};

export default Navbar;
